import { RouterProvider } from "react-router-dom";
import router from "./routers/router";
import './assets/css/reset.css';
import './assets/fonts/CookieRun.css';
import './assets/fonts/SCDream.css';
import './assets/css/common.css';
import './assets/css/meterialicon.css';
function App() {
  return (
      <RouterProvider router={router}></RouterProvider>
  );
}

export default App;
